import React, { useEffect, useState } from 'react';

const ProductSubscription = (props) => {
  const [subscriptionFrequencyOptions, setSubscriptionFrequencyOptions] = useState([]);

  const toggleSubSelectionsFunc = (targetValue) => {
    var freqEl = document.querySelector(
      `#subscription-section select#subFrequencySelect__${props.contentData.partNumber}`
    );

    if (targetValue == 'subscribe') {
      var options = freqEl.options;
      for (var i = 0; i < options.length; i++) {
        var option = options[i];
        if (option.value == '') {
          freqEl.removeChild(option);
        }
      }

      freqEl.disabled = false;
    } else {
      freqEl.appendChild(new Option('Select Frequency', ''));
      freqEl.value = '';
      freqEl.disabled = true;
    }

    props.passedFunctions.updateSubscriptionFrequency(freqEl.value);
  };

  useEffect(() => {
    var subscriptionFreq = props.passedAppFunctions.wasParms.subscriptionFreq;

    if (subscriptionFreq != undefined) {
      setSubscriptionFrequencyOptions(subscriptionFreq.split(','));
    }

    var onceRadio = document.querySelector("input[name=subFrequencyRadio][value='once']");

    if (onceRadio != undefined) {
      onceRadio.checked = true;
    }
  }, []);

  if (props.passedAppFunctions.wasParms.subscriptionsEnabled !== 'true') {
    return null;
  }

  return (
    <div className='m-10 hide-when-international' id='subscription-section'>
      {
        <div className='form-group '>
          <div className='custom-control custom-radio'>
            <input
              type='radio'
              id={'subFrequencyRadio__' + props.contentData.partNumber + '__once'}
              name='subFrequencyRadio'
              className='custom-control-input'
              value='once'
              defaultChecked={true}
              onClick={(e) => toggleSubSelectionsFunc(e.target.value)}
            />
            <label
              className='custom-control-label'
              htmlFor={'subFrequencyRadio__' + props.contentData.partNumber + '__once'}
            >
              ONE TIME PURCHASE
            </label>
          </div>
          <div className='custom-control custom-radio'>
            <input
              type='radio'
              id={'subFrequencyRadio__' + props.contentData.partNumber + '__subscribe'}
              name='subFrequencyRadio'
              className='custom-control-input'
              value='subscribe'
              onClick={(e) => toggleSubSelectionsFunc(e.target.value)}
            />
            <label
              className='custom-control-label'
              htmlFor={'subFrequencyRadio__' + props.contentData.partNumber + '__subscribe'}
            >
              SUBSCRIBE
            </label>
          </div>
          <div>
            <select
              className='form-control'
              id={'subFrequencySelect__' + props.contentData.partNumber}
              name='subFrequencySelect'
              disabled='disabled'
              onChange={(e) => props.passedFunctions.updateSubscriptionFrequency(e.target.value)}
            >
              <option value=''>Select Frequency</option>
              {subscriptionFrequencyOptions.map((subscriptionOption, i) => {
                return (
                  <option key={i} value={subscriptionOption}>
                    Every {subscriptionOption} Days
                  </option>
                );
              })}
            </select>
          </div>
        </div>
      }
    </div>
  );
};

export default ProductSubscription;
